/* eslint-disable no-nested-ternary */
import { VIRTUAL_PAGES } from 'libs/providers/datalayer/constants';
import { PLANS_IDS } from '../constants/plans';

export const getConfirmationFlow = (datalayer: any) =>
  VIRTUAL_PAGES.resumen.flow(datalayer);

export const isKilometersPlanPrice = (
  annualFixedPremiumGps: number | null,
  totalPremium: number,
  offerCode: string,
) => {
  if (offerCode === PLANS_IDS.AEPlanKilometros) {
    return annualFixedPremiumGps;
  }
  return totalPremium;
};

export const priceByQuotas = (installments: any, quotas: number) => {
  const haveQuotas = false;
  if (quotas !== 1) {
    const plan = installments.find(
      (x: any) => x.nombre.split(' ')[0] === String(quotas),
    );

    return plan ? plan.monto : haveQuotas;
  }

  return haveQuotas;
};

export const getTwoFields = (sentence: string) => {
  return sentence.split(' ').splice(0, 2).join(' ');
};
